import QueryStringProvider from './interfaces/QueryStringProvider';

export function getDefaultQueryStringProvider(): QueryStringProvider {
  return {
    GetQueryString: () => window.location.search,
  };
}
